const LoadingIndicator = () => {
  return (
 <div id="loadingIndicator" className="flex items-center justify-center h-screen">
  <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-amber-600"></div>
</div>
  );
};

export default LoadingIndicator;


// const LoadingIndicator = () => {
//   return (
//     <div className="bg-white rounded-xl shadow-md overflow-hidden animate-pulse">
//       <div className="p-6">
//         <div className="flex items-center mb-4">
//           <div className="bg-gray-200 p-3 rounded-lg mr-4">
//             <div className="w-10 h-10 bg-gray-300 rounded-full"></div>
//           </div>
//           <div className="flex-1">
//             <div className="h-5 bg-gray-200 rounded w-3/4 mb-2"></div>
//             <div className="h-3 bg-gray-200 rounded w-1/2"></div>
//           </div>
//         </div>
        
//         <div className="grid grid-cols-2 gap-2 mb-4">
//           <div>
//             <div className="h-3 bg-gray-200 rounded w-3/4 mb-1"></div>
//             <div className="h-4 bg-gray-200 rounded w-1/2"></div>
//           </div>
//           <div>
//             <div className="h-3 bg-gray-200 rounded w-3/4 mb-1"></div>
//             <div className="h-4 bg-gray-200 rounded w-1/2"></div>
//           </div>
//         </div>
        
//         <div className="h-10 bg-gray-200 rounded-lg"></div>
//       </div>
//     </div>
//   );
// };

// export default LoadingIndicator;